export default __webpack_public_path__ + "static/media/duster-techroad-colour-2.2b556192.jpg";